export const Loader = {
    hide: () => document.getElementById('static-loader').style.display = 'none',
    show: () => document.getElementById('static-loader').style.display = 'flex'
}